import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/services/base.service';
import { environment } from 'src/environments/environment';
import { Auditoria } from '../models/auditoria';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class AuditoriaService extends BaseService {

  constructor(protected http: HttpClient) { super(http); }

  public InsertarRegistro(mensaje: Auditoria): Observable<any> {
    const endPoint = `${environment.pagoVinculacionEndPoint}auditoria/Insertar`;
    return this.doPost<Auditoria, boolean>(endPoint, mensaje, this.optsName(''));
  }

}
